import Vue from "vue";
import VueRouter from "vue-router";
// import Home from "@/views/Home.vue";
import store from "@/store";
import { Message } from "element-ui";
import { getDefaultDate } from "@/api/baseInfo";
import { getUrlParams } from "@/utils";
import { parseTime } from "@/utils";
Vue.use(VueRouter);

const originalpush = VueRouter.prototype.push;

VueRouter.prototype.push = function push(location) {
  return originalpush.call(this, location).catch((err) => err);
};

const routes = [
  {
    path: "/",
    redirect: "/search",
  },

  {
    path: "/search",
    name: "search",
    component: () => import("@/views/Search.vue"),
  },
  {
    path: "/detail",
    name: "detail",
    component: () => import("@/views/Detail"),
  },
  {
    path: "/customized",
    name: "customized",
    component: () => import("@/views/Customized"),
  },
  {
    path: "/lifeDiscovery",
    name: "lifeDiscovery",
    component: () => import("@/views/LifeDiscovery"),
  },

  {
    path: "/loadProject",
    name: "loadProject",
    component: () => import("@/views/LoadProject"), //  webpackChunkName: "about"
  },
  {
    path: "/customManage",
    name: "customManage",
    component: () => import("@/views/CustomManage"), //  webpackChunkName: "about"
  },

  //   {
  //     path: "/selector",
  //     name: "selector",
  //     component: () => import("@/views/Selectors.vue"),
  //   },
];

const router = new VueRouter({
  routes,
});

const getDefaultDateFun = async (to, next) => {
  let params = {};
  params.plat = store.state.user.plants
    ? store.state.user.plants.join(",")
    : "";
  await getDefaultDate(params).then((res) => {
    if (res.status == "ok") {
      store.dispatch("user/changeStartMonth", res.result.end);
      store.dispatch("user/changeEndMonth", res.result.end);
      localStorage.setItem("defaultStartMonth", res.result.start);
      localStorage.setItem("defaultEndMonth", res.result.end);
      router.push({
        name: to.name,
        query: {
          start: parseTime(store.state.user.startMonth, "{y}-{m}-{d}"),
          end: parseTime(store.state.user.endMonth, "{y}-{m}-{d}"),
        },
      });
      next();
    }
  });
  //   } else {
  //     return;
  //   }
};
let fullPath = "";
router.beforeEach(async (to, from, next) => {
  if (
    to.path.includes("/search") ||
    to.path.includes("/loadProject") ||
    to.path.includes("/customManage") ||
    to.path.includes("/lifeDiscovery") ||
    to.path.includes("/customized")
  ) {
    store.dispatch("user/changeShowMainHead", false);
  } else {
    store.dispatch("user/changeShowMainHead", true);
  }
  if (to.path.includes("/search") || to.path.includes("/customized")) {
    store.dispatch("user/changeShowTopHead", false);
  } else {
    store.dispatch("user/changeShowTopHead", true);
  }
  if (
    !getUrlParams("start") &&
    !getUrlParams("end") &&
    !store.state.user.startMonth &&
    !store.state.user.endMonth
  ) {
    await getDefaultDateFun(to, next);
  } else {
    if (fullPath == to.fullPath) return next(false);
    fullPath = to.fullPath;
    next();
  }
});

export default router;
